module.exports = __webpack_public_path__ + "static/media/mc.767c37bd.svg";